import { CommonModule } from '@angular/common';
import { Directive, NgModule, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppConfigService } from '@elio/emanager-front/shared/app-config';

@Directive({
  selector: '[elioDisabledFeatureProd]',
})
export class DisabledFeatureProdDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit(): void {
    if (this.appConfigService.getAppConfig().environment !== 'prod') {
      this.addTemplate();
    }
  }

  private addTemplate() {
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [DisabledFeatureProdDirective],
  exports: [DisabledFeatureProdDirective],
})
export class ElioDisabledFeatureProdModule {}
